<template>
  <div class="stockDetail">
    <div class="topMain">
      <p class="pg">{{stockDetailObj.resourceNameCn}}</p>
      <p class="ml">
        <span class="sp">{{stockDetailObj.productNameCn}}</span>
      </p>
      <p class="top">
        {{stockDetailObj.productStockDesc}}
      </p>
      <p style="color: rgb(176, 3, 3); border-bottom: 1px solid #f2f2f2;padding-bottom: 10px;">
        <span v-if="stockDetailObj.recommendation&&stockDetailObj.recommendation!=''">推荐理由：{{stockDetailObj.recommendation}}</span>
        <span style="color:#155969;font-size:12px;">{{stockDetailObj.cancelType==1?'不可取消':
        stockDetailObj.cancelType==5?'随时退':stockDetailObj.cancelType==6?'过期退':'有条件退'}}</span>
      </p>
    </div>
    <div class="inst">
      <p class="bg">预定说明：</p>
      <p>{{stockDetailObj.isSplit===0?'可':'不可'}}拆分购买</p>
      <p><label class="bl">价格有效期：</label>{{productType==1?'长期有效':dateFormatYMDHM(stockDetailObj.saleOptionTime,"-")}}</p>
      <p class="bl"><label class="bl">有效期解释：</label>{{stockDetailObj.optionTimeExplain}}</p>
    </div>
    <div class="inst">
      <p class="bg">费用说明：</p>
      <p>{{stockDetailObj.isVat===0?'含':'不含'}}VAT&nbsp;&nbsp;{{stockDetailObj.isCityTax==0?'含':stockDetailObj.isCityTax==1?'不含':'没有'}}城市税</p>
      <!-- <p>报价含早餐{{pp.breakfastNumber}}份&nbsp;&nbsp;{{pp.breakfastRemark}}</p> -->
      <p><label class="bl">费用说明描述：</label>{{stockDetailObj.costExplain}}</p>
      <p class="bl">可免费提供的设施及服务为：</p>
      <div v-for="(item,index) in stockDetailObj.contains" :key="index+'sheshi'">
        <p v-if="item.type==1||item.type==2">{{item.name}}{{item.number}}份{{item.containDescribe}}</p>
      </div>
      <p class="bl">可有偿提供的设施及服务为：</p>
      <div v-for="(item,index) in stockDetailObj.contains" :key="index+'sheshi1'">
        <p v-if="item.type==3||item.type==4">{{item.name}}{{item.number}}份{{item.containDescribe}}</p>
      </div>
    </div>
    <div class="inst">
      <p class="bg">使用说明：</p>
      <p><label class="bl">预定号：</label>{{stockDetailObj.useNumber}}</p>
      <p>{{stockDetailObj.useMethod}}</p>
      <p><label class="bl">使用说明描述：</label>{{stockDetailObj.useExplain}}</p>
    </div>
    <div class="inst">
      <p class="bg">退改说明：</p>
      <p>{{stockDetailObj.cancelType==1?'不可取消':stockDetailObj.cancelType==5?'随时退':stockDetailObj.cancelType==6?'过期退':'有条件退'}}</p>
      <p v-if="stockDetailObj.cancelTime&&stockDetailObj.cancelTime!=''">产品使用当天{{stockDetailObj.cancelTime}}前可免费取消
      <p v-for="(item,index) in stockDetailObj.cancelPolicyList" :key="index">
        <span v-if="item.cancelData==''">使用日期前{{item.day}}天{{item.cancelTime}}前可免费取消{{item.cancelProportion}}%</span>
        <span v-else>{{dateFormatYMD(item.cancelData,"-")}}日{{item.cancelTime}}前可免费取消{{item.cancelProportion}}%</span>
      </p>
      <p><label class="bl">退改说明：</label>{{stockDetailObj.cancelExplain}}</p>
    </div>
    <div class="inst">
      <p class="bg">其他说明：</p>
      <p><label class="bl">发票须知：</label>{{stockDetailObj.invoiceExplain}}</p>
      <p><label class="bl">其他须知：</label>{{stockDetailObj.otherExplain}}</p>
      <p><label class="bl">安全须知：</label>{{stockDetailObj.securityExplain}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    stockDetailObj:{
      type:Object,
      default:()=>{return {}}
    },
    productType:{
      type:Number,
      default:1,
    }
  }
}
</script>

<style lang="scss" scoped>
.stockDetail{
  margin: 0.18rem;
}
.topMain {
  width: 3.75rem;
  >p{
    margin-bottom: 0.05rem;
  }
  .pg {
    color: #101010;
    font-size: 0.16rem;
    font-weight: bold;
  }
}
.inst {
  margin-top: 0.1rem;
  p {
    font-size: 0.12rem;
    margin-bottom: 0.02rem;
    margin-right: 0.15rem;
  }
  .bg {
    color: #296776;
    font-weight: bold;
    margin-bottom: 0.05rem;
  }
  .bl {
    font-weight: bold;
  }
}
</style>